export default __webpack_public_path__ + "static/media/error_blanco.819267c5.svg";